import axios from "axios";

const apiClient = axios.create({
    baseURL: "https://portal-api.shopgrok.com",
    headers: {
        "Content-Type": "application/json"
    }
});

export default apiClient;
